import React from "react";
import { Button } from '@progress/kendo-react-buttons';
import { useFormikContext } from 'formik';
import {buttonThemeColors} from "../../base/Button/Button.jsx";

export const SubmitButton = ({ children = 'Submit', themeColor = buttonThemeColors.success, disabled, ...otherProps }) => {
    const { isSubmitting, dirty } = useFormikContext();

    return (
        <Button
            type="submit"
            themeColor={themeColor}
            disabled={isSubmitting || !dirty || disabled}
            {...otherProps}
        >
            {isSubmitting ? 'Submitting…' : children}
        </Button>
    );
};
